import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectIsVILoading = createSelector(
  (state: GlobalState) => state.videoIdentification,
  (videoIdentification) => videoIdentification.isLoading,
);

export const selectVIData = createSelector(
  (state: GlobalState) => state.videoIdentification,
  (videoIdentification) => videoIdentification.videoIdentificationData,
);

export const selectVIDetails = createSelector(
  (state: GlobalState) => state.videoIdentification,
  (videoIdentification) => videoIdentification.videoIdentificationDetails,
);
